import ModalService from "services/modal";

export const EDIT_BASIC_INFO_MODULE = "workspace-basic-info";
export const EDIT_CLUSTERS_MODULE = "workspace-clusters";
export const EDIT_NAMESPACES_MODULE = "workspace-namespaces";
export const EDIT_CONTAINER_IMAGES_MODULE = "workspace-container-images";

export const clusterRoleBindingsModal = new ModalService();
export const namespaceRoleBindingsModal = new ModalService();
